/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, Card, CardBody, Flex, Heading } from "@chakra-ui/react";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import { useGetCustomerDetails } from "../../services/customer-api";
import { CustomerDetails as Details } from "../../components/customers/customer-details";
import { HasPermission } from "../../utils/helper";
import { useUser } from "../../hooks/use-user";

export default function CustomerDetails() {
  const [customer, setCustomer] = useState({});
  const user = useUser();
  const params = useParams();
  const {
    mutate: getCustomerDetails,
    data: customerDetailsRes,
    isPending: gettingCustomerDetails,
    error: customerDetailsError,
  } = useGetCustomerDetails();

  useEffect(() => {
    if (customerDetailsRes) {
      setCustomer(customerDetailsRes.data);
    }
  }, [customerDetailsRes, customerDetailsError]);
  useEffect(() => {
    if (params.customerId) {
      getCustomerDetails(params.customerId);
    }
  }, []);
  const canEdit = useMemo(() => {
    return HasPermission(user, "Customer", "Edit");
  }, [user]);
  return (
    <>
      {gettingCustomerDetails ? <Loader /> : <></>}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Customers", link: Paths.customers },
            { text: "Customer Details", isCurrentPage: true },
          ]}
        />

        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <Flex w="100%" justify="space-between" flexDirection="row">
                <Heading>{customer.name}</Heading>

                {canEdit ? (
                  <Button as={Link} to={`${Paths.editCustomer}/${customer.id}`}>
                    Edit
                  </Button>
                ) : (
                  <></>
                )}
              </Flex>
              <div className="add-location-form">
                {customer.name ? <Details customer={customer} /> : <></>}
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
